// import { Button } from "@material-ui/core";
import { motion } from "framer-motion";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { scrollReveal } from "../../animation";
import { useScroll } from "./useScroll";
import Badge from "react-bootstrap/Badge";
// import Img from "react-cool-img";

const myProjects = [
  {
    // image: "/images/reverse-image-querying.png",
    title: " ‘Color Quest’ - Indie-Platformer Game",
    description:
      "Spearheaded programming and analytics efforts for 'Color Quest,' an indie 2D platformer game inspired by Super Mario Bros. with a unique color-changing twist - Link. • Developed key C# scripts using Unity 2D, including mechanics for color-changing player and platforms, super power timer countdown bar, jump mechanics, coin and collectible collection, and collision detection for spikes and moving objects, etc. • This role involved leading the technical development of gameplay features within Unity 2D, ensuring smooth mechanics and optimizing player experience through analytics-driven enhancements.",
    source: "https://github.com/TejasSheth104/SQLinjection",
    // demoLink: "https://whatsapp-clone-53d8c.web.app/rooms/QIPEvsdzwLBr8AcT1WVD",
    badge: "Python | Machine-Learning | ReactJS | SQL Injection",
    // liveweb: "https://www.youtube.com/watch?v=4DTHrXOLHnQ&t=52s",
  },
  {
    // image: "/images/reverse-image-querying.png",
    title:
      "Virtual Human Therapeutics Lab, USC Institute for Creative Technologies",
    description:
      "Developed the BattleBuddy application using Unity 3D for iOS app development, developing a custom C# script for implementing long-press functionality and drag-and-drop features for game objects. • Created a 'Favorite Photo' module enabling users to select and view favorite photos within the app. • Assisted in documentation review and enhancement, engaged in interdisciplinary research on virtual humans' impact on mental and emotional well-being. ",
    source: "https://github.com/TejasSheth104/SQLinjection",
    // demoLink: "https://whatsapp-clone-53d8c.web.app/rooms/QIPEvsdzwLBr8AcT1WVD",
    badge: "Python | Machine-Learning | ReactJS | SQL Injection",
    // liveweb: "https://www.youtube.com/watch?v=4DTHrXOLHnQ&t=52s",
  },
  {
    // image: "/images/reverse-image-querying.png",
    title: " Urban Future’s Data Core, USC Sol Price School of Public Policy",
    description:
      "Led a team of 6 in developing a Python web scraping program to extract research data from Google Scholar by professors, resulting in a comprehensive database accessible to students and faculty. • Implemented agile software development methodologies for efficient project management, overseeing data analysis and visualization to provide actionable insights for public policy and business strategies. ",
    source: "https://github.com/TejasSheth104/SQLinjection",
    // demoLink: "https://whatsapp-clone-53d8c.web.app/rooms/QIPEvsdzwLBr8AcT1WVD",
    badge: "Python | Machine-Learning | ReactJS | SQL Injection",
    // liveweb: "https://www.youtube.com/watch?v=4DTHrXOLHnQ&t=52s",
  },
  {
    // image: "/images/reverse-image-querying.png",
    title: " Real-time Motion Detection System ",
    description:
      "Developed a real-time motion detection system using Python and OpenCV to monitor and detect unusual activities captured by a camera feed. • Implemented algorithms for motion detection and object tracking, enabling the system to identify and track moving objects within the camera's field of view.",
    source: "https://github.com/TejasSheth104/SQLinjection",
    // demoLink: "https://whatsapp-clone-53d8c.web.app/rooms/QIPEvsdzwLBr8AcT1WVD",
    badge: "Python | Machine-Learning | ReactJS | SQL Injection",
    // liveweb: "https://www.youtube.com/watch?v=4DTHrXOLHnQ&t=52s",
  },

  {
    // image: "/images/reverse-image-querying.png",
    title: "Detection of SQL Injection Attacks using Reinforcement Learning",
    description:
      "SQL injection is the most common web application vulnerability. This vulnerability can be generated unintentionally by software developers during the development phase. Thus, a tool to prevent SQLi Attack to improve the security of the website needs to be implemented.",
    source: "https://github.com/TejasSheth104/SQLinjection",
    // demoLink: "https://whatsapp-clone-53d8c.web.app/rooms/QIPEvsdzwLBr8AcT1WVD",
    badge: "Python | Machine-Learning | ReactJS | SQL Injection",
    // liveweb: "https://www.youtube.com/watch?v=4DTHrXOLHnQ&t=52s",
  },
  {
    image: "/images/reverse-image-querying.png",
    title: "Reverse Image Querying",
    description:
      "We have implemented and improvised a rudimentary yet efficient solution by using the cosine similarity model to extract similar images for the given input image from the user. The model used is explained comprehensively together with visual representations. We have also explored multiple use cases that can be used as commercial products. The resulting web application can be utilised to act as a reverse image search engine as a standalone application or can be embedded as a sub-module in a larger application.",
    source: "https://github.com/TejasSheth104/ReverseImageQuerying",
    // demoLink: "https://whatsapp-clone-53d8c.web.app/rooms/QIPEvsdzwLBr8AcT1WVD",
    badge: "Python | Image-Processing",
    // liveweb: "https://www.youtube.com/watch?v=4DTHrXOLHnQ&t=52s",
  },
  {
    image: "/images/student-performance-analysis.png",
    title: "Student Performance Analysis",
    description:
      "A Machine Learning model that predicts the marks obtained by a student in their final semester via regression methodology. It is important to find patterns in the student performance to be able to provide the necessary, accurate and timely diagnosis to the student. It also serves as a basic criterion for institutions to monitor the quality of education provided. The model considers factors such as previous academic record, attendance, socioeconomic background, etc.",
    source: "https://github.com/TejasSheth104/StudentPerformanceAnalysis",
    // demoLink: "https://facebook-clone-ccd54.web.app/",
    badge: "Python | Machine-Learning",
    // liveweb: "https://www.youtube.com/watch?v=_5Q8vTcpjhI",
  },
  {
    image: "/images/expense-manager.png",
    title: "Cloud-based Note Taking App",
    description:
      "A note-taking application using the latest cloud technologies. We solve the problem of slow speed, memory extensive and high cost of allocating resources, even in the cloud by implementing it with asynchronous functions with the concepts of async, await & Promise in TypeScript - React. And, to make it cost-efficient, we make use of serverless technologies",
    source: "https://github.com/grey-hat2003/CDK-note-taking-application",
    // demoLink: "https://linkedin-clone-a7ba5.web.app/",
    badge: "AWS Cloud",
    // liveweb: "https://www.youtube.com/watch?v=CA1xCJvSCw8&t=32s",
  },
  {
    image: "/images/expense-manager.png",
    title: "Expense Manager",
    description:
      "A Java-based Project for managing day-to-day expenses, allowing the user to keep a track of his/her debited & credited amounts on a daily, monthly, or even yearly basis. Also, to notify user if he/she crosses a threshold amount and thus helping them in maintaining their balance and expenses within set boundaries.",
    source: "https://github.com/TejasSheth104/JAVAProject-ExpenseManager",
    // demoLink: "https://linkedin-clone-a7ba5.web.app/",
    badge: "Java",
    // liveweb: "https://www.youtube.com/watch?v=CA1xCJvSCw8&t=32s",
  },
  // {
  //   image: "/images/tic-tac-toe.png",
  //   title: "Python Tic-Tac-Toe GUI",
  //   description: "",
  //   source: "https://github.com/TejasSheth104/MiniProject-Py-Sem4",
  //   // demoLink: "https://shopping-cart-a0d9a.web.app/",
  //   badge: "Python | Tkinter",
  //   // liveweb: "https://www.youtube.com/watch?v=ukYdUnHidq8",
  // },
  // {
  //   image: "/images/hospital-management-system.png",
  //   title: "Hospital Management System",
  //   description:
  //     "A complete Hospital Management System, written in C Programming Language.",
  //   source: "https://github.com/TejasSheth104/Hospital-Management-in-C",
  //   badge: "C",
  //   // demoLink: "/",
  // },
  // {
  //   // image: "/images/covid.png",
  //   title: "E-Yantra 2020",
  //   description:
  //     "",
  //     badge: " ",
  //     source: "https://github.com/TejasSheth104/E-Yantra-2020",
  //   // demoLink: "https://covidsaharsa.netlify.app/",
  // },
];

const Projects = () => {
  const [element, controls] = useScroll();
  return (
    <div className="projects" id="projects">
      <motion.div
        variants={window.innerWidth > 767 ? scrollReveal : null}
        ref={element}
        animate={controls}
        className="container pt-6 pb-6"
      >
        <div className="heading-section">
          <h1>
            <span className="chonburi-font green-text">Pro</span>jects
          </h1>
        </div>
        <div className="projects-cards">
          <Row className="justify-content-center">
            {myProjects.map((project, index) => {
              return (
                <Col md={4} className="mb-5" key={index + 1}>
                  <Badge className="lmckdncd" pill variant="warning">
                    {project.badge}
                  </Badge>
                  {project.liveweb && (
                    <Badge className="jdnkcjd" pill variant="danger">
                      <a
                        rel="noopener noreferrer"
                        href={project.liveweb}
                        target="_blank"
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Youtube
                      </a>
                    </Badge>
                  )}
                  <div className="project-card">
                    {/* <div className="img-section">
                      <Img
                        placeholder="https://p4.wallpaperbetter.com/wallpaper/990/450/548/loading-wallpaper-preview.jpg"
                        src={project.image}
                        error="/images/download.png"
                        alt="React Cool Img"
                      />
                      <div className="imageCardEffect"></div>
                    </div> */}
                    <div className="project-info">
                      <h5 className="color-white font-weight-bold">
                        {project.title}
                      </h5>
                      <p className="color-white">{project.description}</p>
                      <div className="d-flex justify-content-betw een mr-4">
                        <a
                          rel="noopener noreferrer"
                          href={project.source}
                          className="project-card-btn"
                          target="_blank"
                        >
                          Source Code
                        </a>
                        {/* <a
                          rel="noopener noreferrer"
                          href={project.demoLink}
                          className="project-card-btn"
                          target="_blank"
                        >
                          Live Demo
                        </a> */}
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </motion.div>
    </div>
  );
};

export default Projects;
